import React from 'react'
import { Input ,ConfigProvider} from 'antd'

function CustomInput(props) {
  return (
  <ConfigProvider theme={{
    components:{
        Input:{
            paddingBlock:0,
            paddingBlockLG:0,
            paddingBlockSM:0,
            paddingInline:0,
            paddingInlineLG	:0,
            paddingInlineSM:0

        }
    }
  }}>
    <Input style={{height:'38px',paddingLeft:'8px',width:'17rem'}} suffix={<div style={{backgroundColor:"#E7F0F4",height:'100%',display:'flex',alignItems:'center',justifyContent:'center',padding:'0 15px',borderRadius:'0 5px 5px 0'}}>{props.units}</div>} {...props}/>
  </ConfigProvider>
  )
}

export default CustomInput

